export default class FullscreenOverlay {
    constructor({element, options={}}) {
        this.el = element;
        this.options = options;

        const id = this.el.getAttribute('data-fullscreen-overlay-id');
        const openTriggers = document.querySelectorAll(`[data-fullscreen-overlay-open="${id}"]`);
        const closeTriggers = document.querySelectorAll(`[data-fullscreen-overlay-close="${id}"]`);

        this._handleClose = this._handleClose.bind(this);
        this._handleOpen = this._handleOpen.bind(this);
        this._handleKeyDown = this._handleKeyDown.bind(this);

        for (let trigger of openTriggers) {
            trigger.addEventListener('click', this._handleOpen);
        }

        for (let trigger of closeTriggers) {
            trigger.addEventListener('click', this._handleClose);
        }
    }

    _handleClose(e) {
        e.preventDefault();

        this._close();
    }

    _handleKeyDown(e) {

        // ESC key
        if (e.keyCode === 27) {
            this._close();
        }
    }

    _handleOpen(e) {
        e.preventDefault();

        this._open();
    }

    _close() {
        document.body.removeEventListener('keydown', this._handleKeyDown, { passive: true });

        this.el.classList.remove('fullscreen-overlay--visible');

        setTimeout(() => {
            this.el.removeAttribute('data-fullscreen-overlay-active');
            document.body.removeAttribute('data-fullscreen-overlay-active');
        }, 300);

        if (this.options.onClose) {
            this.options.onClose();
        }
    }

    _open() {
        document.body.addEventListener('keydown', this._handleKeyDown, { passive: true });

        this.el.setAttribute('data-fullscreen-overlay-active', true);
        document.body.setAttribute('data-fullscreen-overlay-active', true);

        setTimeout(() => {
            this.el.classList.add('fullscreen-overlay--visible')
        }, 0);

        if (this.options.onOpen) {
            this.options.onOpen();
        }
    }
}



/** WEBPACK FOOTER **
 ** ./js/marketing/components/FullscreenOverlay.js
 **/